import { render, staticRenderFns } from "./sr_number_display.vue?vue&type=template&id=0990a22e"
import script from "./sr_number_display.vue?vue&type=script&lang=js"
export * from "./sr_number_display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports